import React, { useEffect, useContext } from "react";
import LanguageTranslater from "../../HOC/LanguageTranslater";
import "./ProposalVerification.css";
import {
  cameraNewImg,
  otpInsImg,
  photoVerImg,
  policyConfirmation,
  proposalReviewImg,
  videoVerImg,
} from "../../../images/btnIcons";
import { getNewUISteps } from "../../../utils/stepperStep";
import { playVoiceOver, stopAudio } from "../../../utils/handleVoiceAndLang";
import { SpeakerContext } from "../../../context/SpeakerContext";
import { muteAudio } from "../../../utils/handleVoiceAndLang";
import { isPODPosv } from "../../../utils/handleProgress";
import { Button } from 'unified-ui-components-library'
import { payemntIcn, personalDetailsIcn, photoVerificationIcn, proposalReviewIcn, videoConsentIcn } from "../../../images/TeleBindingImages/TeleBindingImages";
import StepItem from "../../TelebindingJourney/PiiDetails/StepItem/StepItem";
import { TELEBINDING_STAGES, TELEBINDING_WAITING_STAGES } from "../../../utils/constants";

const ProposalVerification = ({ goToPage, translate, lPosv, isTelebinding, onProceed, currentStage, isPhoneBanking }) => {
  const { isVoiceOverDisable} = useContext(SpeakerContext)
  
  const journeyBy = localStorage.getItem('journeyBy')
  useEffect(() => {
    if (journeyBy !== 'P' && !isPODPosv() && !isTelebinding) {
      if(isVoiceOverDisable) {
        playVoiceOver("verify-aud", "proposallanguageselected");
        muteAudio("verify-aud");
      }
      else {
        playVoiceOver("verify-aud", "proposallanguageselected");
      }
    }
  }, []);
  let journeySteps = getNewUISteps(isTelebinding);
  const selectedLang = localStorage.getItem("LanguageSelected");

  const hanleBtnClick = () => {
    if(isTelebinding){
      onProceed();
      return;
    }
    let category = localStorage.getItem("category");
    if (journeyBy === 'P' && lPosv === false) {
      category = 'clubbed_otp_question'
    }
    stopAudio("verify-aud");
    goToPage(category);
  };

  const isStepDone = (step) => {
    const completedStages = [];
    if(currentStage === TELEBINDING_STAGES.POSV || currentStage === TELEBINDING_STAGES.CALLBACK_PROCESSING){
      completedStages.push(TELEBINDING_STAGES.PII);
    }
    if(currentStage === TELEBINDING_STAGES.PAYMENT || currentStage === TELEBINDING_STAGES.BACKFLOW_PROCESSING){
      completedStages.push(TELEBINDING_STAGES.POSV);
      completedStages.push(TELEBINDING_STAGES.PII);
    }
    return completedStages.includes(step);
  };

  const getStepsUI = (step, index) => {
    switch (step) {
      case "Photo Verification":
        return (
          <div className="list" key={index}>
            <div className="stepText" >
            <div >{translate('STEP')}</div>
            <div>{index + 1}.</div>
            </div>
            <div className="icon">
              <img src={photoVerImg} alt="icons" />
            </div>
            <div className="listText">{translate("Photo Verification")}</div>
          </div>
        );
      case "Questionnaire":
        return (
          <div className="list" key={index}>
            <div className="stepText" >
            <div >{translate('STEP')}</div>
            <div>{index + 1}.</div>
            </div>
            <div className="icon">
              <img src={proposalReviewImg} alt="icons" />
            </div>
            <div className="listText">{translate("Proposal Review")}</div>
          </div>
        );
      case "Policy Questions":
        return (
          <div className="list" key={index}>
            <div className="stepText" >
            <div >{translate('STEP')}</div>
            <div>{index + 1}.</div>
            </div>
            <div className="icon">
              <img src={proposalReviewImg} alt="icons" />
            </div>
            <div className="listText">{translate("Policy Specific Questions")}</div>
          </div>
        );
      case "Clubbed OTP":
        return (
          <div className="list" key={index}>
            <div className="stepText" >
            <div >{translate('STEP')}</div>
            <div>{index + 1}.</div>
            </div>
            <div className="icon">
              <img src={policyConfirmation} alt="icons" />
            </div>
            <div className="listText">{translate("Policy Confirmation/s")}</div>
          </div>
        );
      case "Consent Recording":
        return (
          <div className="list" key={index}>
            <div className="stepText" >
            <div >{translate('STEP')}</div>
            <div>{index + 1}.</div>
            </div>
            <div className="icon">
              <img src={videoVerImg} alt="icons" />
            </div>
            <div className="listText">{translate("Video Consent")}</div>
          </div>
        );
      case "OTP verification":
        return (
          <div className="list" key={index}>
            <div className="stepText" >
            <div >{translate('STEP')}</div>
            <div>{index + 1}.</div>
            </div>
            <div className="icon">
              <img src={otpInsImg} alt="icons" />
            </div>
            <div className="listText">{translate("OTP Validation")}</div>
          </div>
        );

        case "Personal Details":
        return (
          <StepItem
          key={index}
          index={index}
          icon={personalDetailsIcn}
          text={translate("1.Personal Details")}
          done={isStepDone(TELEBINDING_STAGES.PII)}
        />
        );

      case "Proposal Review":
        return (
          <StepItem
          key={index}
          index={index}
          icon={proposalReviewIcn}
          text={"2.Proposal Review"}
          done={isStepDone(TELEBINDING_STAGES.POSV)}
        />
        );

      case "Photo Verification ":
        return (
          <StepItem
          key={index}
          index={index}
          icon={photoVerificationIcn}
          text={"3.Photo Verification"}
          done={isStepDone(TELEBINDING_STAGES.POSV)}
        />
        );

      case "Video Consent":
        return (
          <StepItem
          key={index}
          index={index}
          icon={videoConsentIcn}
          text={"4.Video Consent"}
          done={isStepDone(TELEBINDING_STAGES.POSV)}
        />
        );

      case "Payment":
        return (
          <StepItem
          key={index}
          index={index}
          icon={payemntIcn}
          text={"5.Payment"}
          done={isStepDone(TELEBINDING_STAGES.PAYMENT)}
        />
        );
      default:
        return null;
    }
  };

  const traslateJourneyInstrunctionForPod = () => {
     if(isPODPosv()) {
      const stringFour = localStorage.getItem("LanguageSelected") === "Assamese" ? "৪" : "4";
      const stringSix = localStorage.getItem("LanguageSelected") === "Assamese" ? "৬" : "6";
      const replaceDigitFour = translate("process_time").replace(stringFour,"2")
      const replaceDigitSix = replaceDigitFour.replace(stringSix,"3")
      return replaceDigitSix
     } else {
      return translate("process_time")
     }
  }

  return (
    <>
      <audio className="aud-el-hide" id="verify-aud"></audio>
      <div className="verificationWrapper">
        <div className="verificationWrapperInner">
          {selectedLang === "eng" ? (
           <h4>
      {isTelebinding ? (
        <>
          <p>Your video verification will take 5-6 minutes and involve {isPhoneBanking ? '4' : '5'} steps.</p>
        </>
      ) : (
        <>
          This process should take{" "}
          <span>{isPODPosv() ? "2-3" : "4-6"} minutes and will include:</span>
        </>
      )}
    </h4>
          ) : (
            <h4>{traslateJourneyInstrunctionForPod()}</h4>
          )}
          <div className="verificationList">
            {journeySteps.map((step, i) => getStepsUI(step, i))}
          </div>
        </div>
        {journeyBy !== 'P' && <div className="cameraAccess">
          <img src={cameraNewImg} alt="camera icon" />
          <p>{translate('Camera and microphone access required')}</p>
        </div>}
        <div className="btnWrapper">
          <Button buttonType="primary" width="264" onClick={hanleBtnClick}>
            {isTelebinding ? "Proceed" : translate("Let’s Start")}
          </Button>
        </div>
      </div>
    </>
  );
};

export default LanguageTranslater(ProposalVerification);
